import * as AbWorkflow from '../api/util/workflow'
import * as Data from '../api/archibus-v2/DataApi'

export const fetchSearchResults = searchTerm => {
  return AbWorkflow.callMethod('AbCommonResources-KioskSearch-doSearch', [
    [searchTerm]
  ]).then(result => {
    if (result.code === 'executed') {
      return Promise.resolve(result.data)
    } else {
      return Promise.reject('search error')
    }
  })
}

export const searchEmployees = ({searchTerm}) => {
  return Data.getDataFromDataSource(
    'ab-self-service.axvw',
    'employeeSearch',
    null,
    [
      {
        name: 'searchString',
        value: '%' + searchTerm.toUpperCase().trim() + '%'
      },
    ]
  ).then(results => {
    const {data} = results
    return Promise.resolve(data)
  })
}
